<div class="container">
  <div class="title">DatePicker</div>
  <app-date-picker />

  <div class="title">TimePicker</div>
  <app-time-picker />

  <div class="title">Input Address</div>
  {{ addressControl | json }}
  <app-input-address [(ngModel)]="addressControl" />

  <div class="title">Radio Card</div>
  {{ radioCardControl }}
  <app-radio-card
    radioValue="test1"
    icon="icon-delivery-service-outline"
    label="Hand it to Me"
    name="radio-card-test"
    [(ngModel)]="radioCardControl"
  />

  <app-radio-card
    radioValue="test2"
    icon="icon-delivery-service-outline"
    label="Hand it to Me"
    name="radio-card-test"
    [subitems]="cardSubitems"
    [(ngModel)]="radioCardControl"
  />

  <app-radio-card
    radioValue="test3"
    icon="icon-delivery-location-outline"
    label="Leave at Location"
    name="radio-card-test"
    [subitems]="cardSubitems"
    [(ngModel)]="radioCardControl"
  />

  <div class="title">Textarea</div>
  <pre>{{ textarea }}</pre>
  <app-textarea [(ngModel)]="textarea" />

  <div class="title">Input</div>
  <pre>{{ input.value }}</pre>
  <app-input [formControl]="input" />

  <div class="title">Buttons</div>
  <app-button>Default Button</app-button>
  <div class="items">
    <app-button [size]="ButtonSize.Small">Small Button</app-button>
    <app-button [size]="ButtonSize.Medium">Medium Button</app-button>
    <app-button [size]="ButtonSize.Large">Large Button</app-button>
  </div>
  <div class="items">
    <app-button [style]="ButtonStyle.Primary"> Primary Button </app-button>
    <app-button [style]="ButtonStyle.Secondary"> Secondary Button </app-button>
    <app-button [style]="ButtonStyle.Contrast"> Contrast Button </app-button>
  </div>
  <div class="items">
    <app-button [disabled]="true">Disabled Button</app-button>
  </div>

  <div class="title">Option Switcher</div>
  <pre>{{ optionSwitcher | json }}</pre>
  <app-option-switcher
    [(ngModel)]="optionSwitcher"
    [options]="[
      { id: 'delivery', name: 'Delivery', description: '20-25 min' },
      { id: 'pickup', name: 'Pickup', description: '0.3 mi - 10-20 min' }
    ]"
  />
  <app-option-switcher
    [(ngModel)]="optionSwitcher"
    [disabled]="true"
    [options]="[
      { id: '1', name: 'Delivery', description: '20-25 min' },
      { id: '2', name: 'Pickup', description: '0.3 mi - 10-20 min' }
    ]"
  />

  <div class="title">Search</div>
  <pre>{{ search }}</pre>
  <app-search [(ngModel)]="search" placeholder="Just test" />
  <app-search [(ngModel)]="search" [disabled]="true" placeholder="Disabled" />

  <div class="title">Radio Buttons</div>
  <form [formGroup]="radioForm">
    <pre>{{ radioForm.get('value')?.value }}</pre>
    <app-radio
      name="test"
      formControlName="value"
      radioValue="tomato"
      label="Tomato"
    />
    <app-radio
      name="test"
      formControlName="value"
      radioValue="cucumber"
      label="Cucumber"
    />
    <app-radio
      name="test"
      formControlName="value"
      radioValue="olives"
      label="Olives"
    />
  </form>

  <div class="title">Counter</div>
  <pre>{{ counter }}</pre>
  <app-counter [(ngModel)]="counter" />

  <div class="title">Dialog</div>
  <app-button (click)="openTestDialog()">Open Dialog</app-button>
</div>
